import { mapGetters, mapActions } from 'vuex';

export default {
  components: {
  },
  data() {
    return {
      entreprise_nom: '',
      editedUser: {},
      loading: true,
      categories: [],
    }
  },

  validations() {
    return {

    }
  },

  computed: {
    ...mapGetters([
      'auth',
      'users',
      'entreprises',
    ]),
    usersWithoutYourself() {
      return this.users.filter((user) => user.id !== this.auth.user.id)
    }
  },

  methods: {

    ...mapActions([
      'getUsers',
      'setUsers',
      'setUser',
      'getEntreprises',
      'createEntreprise',
      'destroyUser',
    ]),

    confirmDeleteUser(user) {
      this.$bvModal.msgBoxConfirm('Êtes-vous sûr de vouloir supprimer l\'utilisateur '+user.firstname+' '+user.lastname+'?').then(confirm => {
        if(confirm) {
          this.destroyUser(user).then(() => {
            this.showToast("Utilisateur supprimé")
            this.getUsers()
          })
        }
      })
    },

    getStatut(entrepriseId) {
      let entreprise = this.entreprises.find(e => (e.id === entrepriseId))
      if(entreprise) return entreprise.statut
      return ""
    },

    activateEdit(user) {
      if(this.editedUser.id) {
        this.desactivateEdit(this.editedUser)
      }
      this.editedUser = user
      this.editedUser.prevEmail = user.email
    },

    desactivateEdit() {
      this.users.find(u => u.id == this.editedUser.id).email = this.editedUser.prevEmail
      this.editedUser = {}
    },

    showToast(message) {
      this.$toasted.show(message, {
        icon: {
          name: 'user-check',
        },
        theme: "outline",
        position: "bottom-center",
        duration : 2000
      });
    },

    validateModalEntreprise() {
      if(this.entreprise_nom.length > 0 && undefined === this.entreprises.find(e => e.nom === this.entreprise_nom)) {
        this.createEntreprise({nom: this.entreprise_nom}).then((response) => {
          this.showToast("Société créée");
          this.getEntreprises();
        });
      }
    },

    updateRole(user) {
      this.setUsers(user).then(() => {
        this.showToast("Utilisateur mis à jour")
      });
    },

    updateCategories(user) {
      this.setUsers(user).then(() => {
        this.showToast("Catégories de l'utilisateur mises à jour")
      });
    },

    updateEntreprise(user) {
      this.setUser(user).then(() => {
        this.showToast("Utilisateur mis à jour")
      });
    },

    saveUser(user) {
      this.setUser(user).then(() => {
        this.showToast("Utilisateur mis à jour")
      });
      this.editedUser = {}
    }

  },

  mounted() {
    this.getUsers().then(() => this.loading = false);
    this.getEntreprises();
    window.axios.get("/api/categories").then((response) => {
      this.categories = response.data;
    });
  },

  updated() {

  },


}